// can be used to solve the page reload problem on clicking back / cancel
export const goBack = (navigate, noOfRoutesToGoBack = 1) => {
  const fullPath = window.location.pathname;
  // OWNERSHIP:Roy
  // Strip the product basename (e.g. /em, /am, /ra, /em-msp) so we operate
  // on the path relative to the Router's basename, matching what navigate() expects.
  const basenameMatch = fullPath.match(/^\/(am|em|ra)(-msp)?(\/.*)?$/);
  const relativePath = basenameMatch ? basenameMatch[3] || "/" : fullPath;

  const segments = relativePath.split("/");
  const newPath = segments.slice(0, -noOfRoutesToGoBack).join("/") || "/";

  navigate(newPath);
};

//can be used for devices overview page redirection without reload
export const redirectToDeviceOverview = (navigate, path = null, state = {}) => {
  const prevUrl = window.location.pathname + window.location.search;
  localStorage.setItem("previousUrl", prevUrl);
  let destination = "/app/device-details";
  if (path === null) destination = destination + "/overview";
  else destination = destination + path;
  navigate(destination, {
    state: state,
  });
};

// can be used to redirect remote-control device links to the shared overview
export const redirectToRemoteDeviceOverview = (navigate, path = null) => {
  const prevUrl = window.location.pathname + window.location.search;
  localStorage.setItem("previousUrl", prevUrl);
  let destination = "/app/device-details";
  if (path === null) destination = destination + "/overview";
  else destination = destination + path;
  navigate(destination);
};

//can be used for software overview page redirection without reload
export const redirectToSoftwareOverview = (navigate) => {
  const prevUrl = window.location.pathname + window.location.search;
  localStorage.setItem("previousUrl", prevUrl);
  navigate("/app/inventory/apps/info");
};

//can be used for redirection to a given route without reload
export const redirectToPage = (navigate, path) => {
  navigate(path);
};
